/**
 * Product Media Fits Popup
 * Moves popup to body on open so fixed positioning works
 */
document.addEventListener('DOMContentLoaded', () => {
  const strips = document.querySelectorAll('[data-fits-strip]');

  strips.forEach((strip) => {
    const toggleBtn = strip.querySelector('[data-fits-toggle]');
    const popup = strip.querySelector('[data-fits-popup]');

    if (!toggleBtn || !popup) return;

    // Move popup to body so position:fixed works regardless of parent transforms
    document.body.appendChild(popup);

    const overlay = popup.querySelector('[data-fits-overlay]');
    const closeBtn = popup.querySelector('[data-fits-close]');

    const openPopup = () => {
      popup.setAttribute('aria-hidden', 'false');
      const sheet = popup.querySelector('.fits-popup__sheet');
      if (sheet) {
        sheet.style.animation = 'none';
        sheet.offsetHeight; // Force reflow
        sheet.style.animation = '';
      }
      popup.style.animation = 'none';
      popup.offsetHeight;
      popup.style.animation = '';
      document.body.style.overflow = 'hidden';
    };

    const closePopup = () => {
      popup.classList.add('fits-popup--closing');
      setTimeout(() => {
        popup.setAttribute('aria-hidden', 'true');
        popup.classList.remove('fits-popup--closing');
        document.body.style.overflow = '';
        toggleBtn.blur();
      }, 250);
    };

    toggleBtn.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      openPopup();
    });

    if (closeBtn) {
      closeBtn.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        closeBtn.blur();
        closePopup();
      });
    }

    popup.addEventListener('click', (e) => {
      if (e.target === popup) {
        closePopup();
      }
    });

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && popup.getAttribute('aria-hidden') === 'false') {
        closePopup();
      }
    });
  });
});